import React, { useState } from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaGooglePlay,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";

import logoIcon from "../../Assets/Logo/Logo copy.png";

const Footer = () => {
  const [email, setEmail] = useState("");
  return (
    <div className="footer-bg-section">
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-4 mb-md-0">
              <img src={logoIcon} alt="Icon" className="footer-icon" />
              <div className="socials-margin">
                <div className="social-icons">
                  <span className="me-3">
                    <a href="#">
                      <FaFacebook />
                    </a>
                  </span>
                  <span className="me-3">
                    <a href="#">
                      <FaLinkedin />
                    </a>
                  </span>
                  <span className="me-3">
                    <a href="#">
                      <FaInstagram />
                    </a>
                  </span>
                  <span>
                    <a href="#">
                      <FaTwitter />
                    </a>
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-4 mb-md-0">
              <div className="newsletter">
                <p className="newsletter-subheading">
                  We provide fast, reliable, and affordable ISO certification
                  services to help businesses meet global standards. Partner
                  with us to build trust, improve quality, and grow with
                  confidence.
                </p>
              </div>
            </div>

            <div className="col-md-2 mb-4 mb-md-0">
              <h3 className="mb-3 footer-links-name">Useful links</h3>
              <ul>
                <li className="mb-2">
                  <Link to="/">Home</Link>
                </li>
                <li className="mb-2">
                  <Link to="/about">About Us</Link>
                </li>
                <li className="mb-2">
                  <Link to="/services">Services</Link>
                </li>
                <li className="mb-2">
                  <Link to="/verify-certification">Verify Certificate</Link>
                </li>
                <li className="mb-2">
                <Link to="/contact">Contact</Link>
              </li>
              </ul>
            </div>

            <div className="col-md-2 mb-4 mb-md-0">
              <h3 className="mb-3 footer-links-name">Useful Links</h3>
              <ul>
                <li className="mb-2">
                  <Link to="#">Terms and Conditions</Link>
                </li>
                <li className="mb-2">
                  <Link to="#">Privacy Policy</Link>
                </li>
                {/* <li className="mb-2">
                  <Link to="career">Career</Link>
                </li> */}
              </ul>
            </div>
          </div>
          <div class="footer-bottom">
            {/* <div class="footer-left">©2022-2025 Levon Techno Solution.</div> */}
            <div class="footer-center">
              <a href="#">Term of Service</a>
              <a href="#">Privacy Policy</a>
              <a href="#">Language</a>
            </div>
            <div class="footer-right">
              <span>🌐 English</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
